import { Conditionnement } from '@/model/conditionnement';
import { uniteService } from './unites';
import { UniteModel } from './unites/unite.model';

function getQuantiteUnite (quantite: number, conditionnement: Conditionnement, unite: string): number {
  const unitebase = uniteService.getUnite(conditionnement.codeUniteBase);
  const conditionnementUnite = UniteModel.build(conditionnement.code, conditionnement.libelle, 'MASSE', unitebase, conditionnement.facteurUniteBase);

  return uniteService.convertion(quantite, conditionnementUnite, unite);
}

export { getQuantiteUnite };
